module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/express-truck-ddd799dcb92e1ee77a03c4a1592f4fac.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/express-truck.svg
// module id = qrcw
// module chunks = 24